import { useFormContext } from 'react-hook-form'
import TextField from '@mui/material/TextField'


/**
 * @param {import('@mui/material').TextFieldProps & {
 *   name: string
 * }} props
 */
export default function FormTextField({
    name,
    children,
    ...props
}) {
    const {
        register,
        formState: { errors }
    } = useFormContext()

    const handleEnter = e => {
        props.onKeyDown?.(e)
        if (e.key === 'Enter') {
            e.preventDefault()
            e.target.blur()
            e.currentTarget.blur()
        }
    }

    return (
        <TextField
            margin='normal'
            fullWidth
            variant='filled'
            onKeyDown={handleEnter}
            {...props}
            {...register(name)}
            error={!!errors[name]}
            helperText={
                errors[name]?.message ||
                props.helperText ||
                ''
            }
        >
            {children}
        </TextField>
    )
}